<div class="arts-play-page">

  <product-page #products
    [mainFilterName]="'игры'"
    [filterName]="'игры'"
    [productType]="'games'"
    [pageName]="'games'"
    [showFilters]="true"
  ></product-page>



</div>
